import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  ShopTarifierungRequestEvents,
  TarifiereAngebotForShopAction,
} from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { TaasRequestModel, TaasResponseModel, TaasTkvV2Data } from '@ps20/bff-models';
import { CallEffect, ForkEffect, SelectEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasTkvV2DataForShop } from './transformer/tkvData.transformer';
import { getVersichertesRisiko } from './continueToDashboardSaga';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasTkvV2Data
>(App.TKV_V2, getVersichertesRisiko);
export const shopTarifierer = new ShopTarifierer({
  appId: App.TKV_V2,
  taasDataBuilder: buildTaasTkvV2DataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungTkv(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV_V2,
    safeSaga(callSuccessOnMatchingAngebotsId, App.TKV_V2),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(callTarifierungOnMatchingAngebotsId, App.TKV_V2),
  );
}

export function* callTarifierungOnMatchingAngebotsId(
  tarifiereAngebotAction: TarifiereAngebotForShopAction,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const angebotsIdIsMatching = appState.angebotsId === tarifiereAngebotAction.payload.angebotsId;
  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.callTarifierung, tarifiereAngebotAction);
  }
}

export function* callSuccessOnMatchingAngebotsId(
  successAction: DoRequestResponse<TaasResponseModel, TaasRequestModel<TaasTkvV2Data>>,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const originEvent: TarifiereAngebotForShopAction =
    successAction.doRequestAction.payload.originEvent;
  const angebotsIdIsMatching = appState.angebotsId === originEvent.payload.angebotsId;

  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.handleSuccess, successAction);
  }
}
